var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 336,
    height: 399,
    fill: "none",
    viewBox: "0 0 336 399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.541
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)",
    opacity: 0.568
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.948,
    cy: 199.4,
    fill: "url(#paint0_linear)",
    rx: 90.4,
    ry: 58.941,
    transform: "rotate(90 167.948 199.4)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)",
    opacity: 0.648
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3C2ACF",
    fillRule: "evenodd",
    d: "M117.909 162.474l9.668 25.491 35.925 26.304 19.245 3.531 10.802 8.874-3.419-32.1-18.583-15.974-17.885-8.8-35.753-7.326z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_radial)",
    fillRule: "evenodd",
    d: "M113.774 141c9.66 38 12.779 51.621 57.455 65.81 44.675 14.19 56.013 47.928 60.585 75.059 4.572 27.131-103.442 51.979-103.442 51.979l-68.39-88.233-18.614-130.717S104.115 103 113.774 141z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    width: 335.344,
    height: 398.263,
    x: 0.277,
    y: 0.268,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 54.366
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    width: 158.276,
    height: 146.835,
    x: 76.59,
    y: 121.156,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 20.659
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(154.145 60.85 119.175) scale(104.501 115.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 77.548,
    x2: 77.548,
    y1: 140.459,
    y2: 258.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72ADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D3CE2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA4);
export default __webpack_public_path__ + "static/media/a4.8aa5d5cc4485a16427f651104d002ca4.svg";
export { ForwardRef as ReactComponent };